const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export function getImageUrl(photo) {
  if (!photo) return '';
  if (photo.startsWith('http://') || photo.startsWith('https://')) return photo;
  return `${API_BASE}${photo}`;
}
